import React from 'react';
import './WhatWeDo.css';
import Footer from '../components/Footer';

const WhatWeDo = () => {
  const tents = [
    // First three existing cards
    {
      title: "Sleeping Tents",
      image: "/images/tent-types/SLEEPING TENT.webp",
      description: "Sleeping tents are designed for comfort and privacy, providing a safe and cozy space for individuals or small groups, making them ideal for camping and outdoor events.",
      materials: "Waterproof polyester or nylon with reinforced seams.",
      specifications: [
        "Sizes: Single, double, and family options available.",
        "Weight: Lightweight for easy transport.",
        "Customization Options: Color choices and internal dividers for privacy."
      ]
    },
    {
      title: "Lounge Tents",
      image: "/images/tent-types/LOUNGE TENT.webp",
      description: "High-end tents provide luxurious accommodations for VIP guests, featuring elegant designs and high-quality materials.",
      materials: "Soft, durable fabrics that are weather-resistant.",
      specifications: [
        "Sizes: Various sizes for different settings.",
        "Furniture Options: Options for furnishings or seating.",
        "Customization Options: Decorative elements like drapes or lighting."
      ]
    },
    {
      title: "High-End Clientele Tents",
      image: "/images/tent-types/HIGH END CLIENTELE TENT.webp",
      description: "Lounge tents create a relaxed atmosphere for gatherings or rest areas at events, offering shade and comfort.",
      materials: "Premium fabrics with custom finishes.",
      specifications: [
        "Sizes: Custom designs to suit the client's requirement",
        "Luxury Amenities: Options for furnishing and amenities.",
        "Customization Options: Tailored designs to meet specific needs and preferences."
      ]
    },
    // Adding six new cards
    {
      title: "Mess Tents",
      image: "/images/tent-types/MESS TENT.webp",
      description: "Mess tents create a communal dining area for groups, providing a comfortable space to gather and enjoy meals together.",
      materials: "Waterproof materials to withstand outdoor conditions.",
      specifications: [
        "Sizes: Custom sizes to suit different group sizes.",
        "Weight: Designed for easy assembly.",
        "Customization Options: Flexible seating arrangements and color selections for events."
      ]
    },
    {
      title: "Event Tents",
      image: "/images/tent-types/EVENTS TENT.webp",
      description: "Event tents are ideal for weddings, parties, and corporate events, providing elegant solutions for outdoor gatherings.",
      materials: "High-quality canvas designed for durability.",
      specifications: [
        "Sizes: Various sizes to accommodate small and large crowds.",
        "Customization Options: Lighting, flooring, and decor options available."
      ]
    },
    {
      title: "Kitchen Tents",
      image: "/images/tent-types/KITCHEN TENT.webp",
      description: "Kitchen tents provide a sheltered area for cooking and meal preparation, keeping staff safe from weather conditions.",
      materials: "Fire-retardant fabric, waterproof, and UV-resistant materials.",
      specifications: [
        "Sizes: Various sizes for different cooking setups.",
        "Ventilation: Mesh windows for airflow.",
        "Customization Options: Layout designs for tables and equipment."
      ]
    },
    {
      title: "Massage/Spa Tents",
      image: "/images/tent-types/SPA TENT.webp",
      description: "Massage and spa tents provide a serene environment for relaxation and wellness treatments, ideal for outdoor events and retreats.",
      materials: "Soft, breathable fabrics with privacy features.",
      specifications: [
        "Sizes: Available in various sizes for different setups.",
        "Design Features: Designed for tranquility.",
        "Customization Options: Decor and layout options to enhance relaxation."
      ]
    },
    {
      title: "Reception Tents",
      image: "/images/tent-types/RECEPTION TENT.webp",
      description: "Reception tents create a welcoming area for guests at events, providing shelter and comfort during arrivals.",
      materials: "Durable fabrics suitable for various weather conditions.",
      specifications: [
        "Sizes: Flexible sizes based on event requirements.",
        "Design Features: Open layout for easy flow of guests.",
        "Customization Options: Branding opportunities and interior designs."
      ]
    },
    {
      title: "Mountain Tents",
      image: "/images/tent-types/MOUNTAIN TENT.webp",
      description: "Mountain tents are designed for extreme conditions, suitable for hiking and camping expeditions, and are lightweight for easy transport.",
      materials: "Tear resistant fabrics and waterproof materials.",
      specifications: [
        "Weight: Lightweight for easy transport.",
        "Setup: Quick assembly features.",
        "Customization Options: Options for additional insulation and color choices for visibility."
      ]
    },
    // Adding 5 new tent cards
    {
      title: "Store Tents",
      image: "/images/tent-types/STORAGE TENT.webp",
      description: "Store tents provide temporary retail space for markets and exhibitions, making it easy for businesses to set up and operate.",
      materials: "Durable canvas or polyester with reinforced frames.",
      specifications: [
        "Sizes: Available with weatherproof and soundproofing",
        "Accessibility: Wide openings for easy access",
        "Customization Options: Branding options with custom graphics and color choices."
      ]
    },
    {
      title: "Hospital Tents",
      image: "/images/tent-types/MOUNTAIN TENT.webp",
      description: "Hospital tents provide emergency medical care and triage area including shelter during disaster events.",
      materials: "Waterproof and fire-retardant fabric with durable construction.",
      specifications: [
        "Sizes: Available in various sizes to accommodate different medical setups",
        "Design Features: Features for air circulation and privacy",
        "Customization Options: Designated areas for patient care and storage."
      ]
    },
    {
      title: "Refugee Tents",
      image: "/images/tent-types/REFUGEE TENT.webp",
      description: "Refugee tents provide temporary shelter for displaced individuals and families, ensuring safety and protection from elements.",
      materials: "Strong, weather-resistant materials.",
      specifications: [
        "Sizes: Designed to house multiple individuals.",
        "Easy Assembly: Quick setup for urgent needs.",
        "Customization Options: Color options for safety and comfort."
      ]
    },
    {
      title: "Staff Tents",
      image: "/images/tent-types/STAFF TENT.webp",
      description: "Staff tents provide comfortable living spaces for workers at events or camps, ensuring they have a place to rest.",
      materials: "High-durability materials for longevity and weatherproof fabric.",
      specifications: [
        "Sizes: Varying sizes based on staff numbers.",
        "Accessibility: Easy entry/exits.",
        "Customization Options: Branding options with custom graphics and color choices."
      ]
    },
    {
      title: "Office Tents",
      image: "/images/tent-types/OFFICEE TENT.webp",
      description: "Office tents create a professional workspace in outdoor settings, suitable for remote work environments.",
      materials: "Durable, weatherproof materials with insulation for climate control.",
      specifications: [
        "Sizes: Flexible sizes for different team sizes.",
        "Power Solutions: Options for electrical installations.",
        "Customization Options: Layouts for desks and workstations, and branding elements."
      ]
    }
  ];

  return (
    <div className="what-we-do-page">
      <section className="hero-section">
        <div className="container">
          <div className="content-wrapper">
            <div className="text-content">
              <h1>What We Do</h1>
              <p>
                We provide high-quality, weather-resistant tents designed for both personal 
                and commercial use. Built for strength and durability, our tents ensure 
                comfort, security, and flexibility in any environment.
              </p>
              <p>
                From temporary setups to permanent installations, we offer customized 
                solutions that meet the highest standards of quality and performance.
              </p>
            </div>
            <div className="image-content">
              <div className="image-stack">
                <img 
                  src="/images/aboutSmallImg4-min.jpg" 
                  alt="Luxury tent installation" 
                  className="back-image"
                />
                <img 
                  src="/images/aboutSmallImg-min.jpg" 
                  alt="Tent with wooden deck" 
                  className="front-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="explore-tents-section">
        <div className="container">
          <h2>Explore Our Tents</h2>
          <div className="tents-grid">
            {tents.map((tent, index) => (
              <div className="tent-card" key={index}>
                <div className="tent-image">
                  <img src={tent.image} alt={tent.title} />
                  <div className="tent-title">
                    <h3>{tent.title}</h3>
                  </div>
                </div>
                <div className="tent-content">
                  <p className="description">{tent.description}</p>
                  <h4>Materials Used</h4>
                  <p className="materials">{tent.materials}</p>
                  <h4 className="specifications">Specifications:</h4>
                  <ul>
                    {tent.specifications.map((spec, i) => (
                      <li key={i}>{spec}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-choose-section">
        <div className="container">
          <h2>Why Choose our tents?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>Premium Materials</h3>
              <div className="icon">
                <img src="/images/premium-quality-icon.svg" alt="Premium Quality" />
              </div>
              <p>
                We use ISO-certified materials that are rigorously tested for strength, weather resistance, and durability, ensuring long-lasting performance in various conditions.
              </p>
            </div>

            <div className="feature-card">
              <h3>Weatherproofing Standards</h3>
              <div className="icon">
                <img src="/images/weatherproof-icon.svg" alt="Weatherproofing" />
              </div>
              <p>
                All tents undergo weatherproofing tests to ensure they can withstand the elements. Our waterproofing meets industry standards to provide reliable protection in any climate.
              </p>
            </div>

            <div className="feature-card">
              <h3>Eco-Friendly Options</h3>
              <div className="icon">
                <img src="/images/eco-friendly-icon.svg" alt="Eco Friendly" />
              </div>
              <p>
                We offer sustainable materials and production practices for clients who prioritize environmental responsibility. Our eco-friendly options maintain the same high quality as our standard tents.
              </p>
            </div>

            <div className="feature-card">
              <h3>Safety Certifications</h3>
              <div className="icon">
                <img src="/images/Safety Certification.svg" alt="CE Certification" />
              </div>
              <p>
                Our materials meet fire-resistance and child-safety standards, providing safe, dependable shelter for diverse uses, from family events to professional settings.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="reviews-section">
        <div className="container">
          <h2>Listen to what our customers says</h2>
          <p className="subtitle">Read some of our verified reviews from Google Reviews</p>
          
          <div className="google-rating">
            <img 
              src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
              alt="Google" 
              className="google-logo" 
            />
            <div className="stars">
              {[...Array(5)].map((_, index) => (
                <span key={index} className="star">★</span>
              ))}
            </div>
          </div>

          <div className="reviews-grid">
            {/* First Row */}
            <div className="review-card">
              <div className="reviewer">
                <img 
                  src="https://ui-avatars.com/api/?name=Collins+Ogilo&background=random" 
                  alt="Collins Ogilo" 
                  className="avatar" 
                />
                <h3>Collins Ogilo</h3>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, index) => (
                  <span key={index} className="star">★</span>
                ))}
              </div>
              <p>Nice canvas products especially their Lodge's and tent professional Workmanship at its best</p>
            </div>

            <div className="review-card">
              <div className="reviewer">
                <img 
                  src="https://ui-avatars.com/api/?name=Focca+Tz&background=random" 
                  alt="focca Tz" 
                  className="avatar" 
                />
                <h3>focca Tz</h3>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, index) => (
                  <span key={index} className="star">★</span>
                ))}
              </div>
              <p>Great services,good hospitality,highly recommended</p>
            </div>

            <div className="review-card">
              <div className="reviewer">
                <img 
                  src="https://ui-avatars.com/api/?name=Ronald+Odinga&background=random" 
                  alt="RONALD ODINGA" 
                  className="avatar" 
                />
                <h3>RONALD ODINGA</h3>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, index) => (
                  <span key={index} className="star">★</span>
                ))}
              </div>
              <p>excellent work. well established in-house company</p>
            </div>

            {/* Second Row */}
            <div className="review-card">
              <div className="reviewer">
                <img 
                  src="https://ui-avatars.com/api/?name=Suzy+Adamu&background=random" 
                  alt="Suzy Adamu" 
                  className="avatar" 
                />
                <h3>Suzy Adamu</h3>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, index) => (
                  <span key={index} className="star">★</span>
                ))}
              </div>
              <p>High quality items, very clean</p>
            </div>

            <div className="review-card">
              <div className="reviewer">
                <img 
                  src="https://ui-avatars.com/api/?name=Sambo+Sambo&background=random" 
                  alt="Sambo Sambo" 
                  className="avatar" 
                />
                <h3>Sambo Sambo</h3>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, index) => (
                  <span key={index} className={`star ${index >= 4 ? 'empty' : ''}`}>★</span>
                ))}
              </div>
              <p>They are on time to complete your order</p>
            </div>

            <div className="review-card">
              <div className="reviewer">
                <img 
                  src="https://ui-avatars.com/api/?name=Elijah+Kitomari&background=random" 
                  alt="Elijah Kitomari" 
                  className="avatar" 
                />
                <h3>Elijah Kitomari</h3>
              </div>
              <div className="stars">
                {[...Array(5)].map((_, index) => (
                  <span key={index} className="star">★</span>
                ))}
              </div>
              <p>Best manufacturers ever</p>
            </div>
          </div>
        </div>
      </section>
      
    </div>
  );
};

export default WhatWeDo; 